<template>
    <div>
      <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
        <Loading />
      </div>
      <div v-else class="checkmark-container">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <img v-if="checkin.checkpoint.additionalSettings.showQr" style="height: 100px; width: 100px;" :src="$store.state.baseUrl + checkin.attendees[0].qr" alt="QR Code">
          <img v-if="checkin.checkpoint.additionalSettings.showEventLogo" style="height: 70px;" :src="$store.state.baseUrl + event.logo.path" alt="Event Logo" srcset="">
        </div>
        <p style="font-size: 1.2rem; margin-top:1rem;">{{ checkin.status }}</p>
        
        <p>Your Code is : <span style="font-weight: bold; margin-right: 5px;">{{ checkin.code }}</span> for : <span style="font-weight: bold;">{{ checkin.checkpoint.name }}</span></p>
        <div v-html="checkin.checkpoint.additionalSettings.successPageMessage"></div>
        <div class="d-flex align-items-center" style="gap:10px;">
          <div class="my-4 d-flex" style="flex-direction: column; gap: 10px; width: max-content;">
            <p class="p-0 m-0" v-for="name in checkin.names" :key="name._id">{{ name.firstName + ' ' + name.lastName }}</p>
          </div>
        </div>

        <div class="d-flex" style="gap:10px;">
          <el-button @click="$router.push('/')" class="mt-4">
            Home
          </el-button>
          <el-button v-if="checkin.checkpoint.additionalSettings.showPrintButton" @click="print" class="m-0 mt-4 btn btn-primary">
            Print
          </el-button>

        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import http from "../../http.js";
import Loading from "../Loading.vue"
export default {
  components: { Loading },
  props:{
    message: {
      type: String,
      default: "Successful"
    }
  },
  computed:{
    ...mapState(['event'])
  },  
  data(){
    return {
      checkin: null,
      loading: true
    }
  },
  methods:{
    print(){
      window.print();
    }
  },
  async mounted(){
    const { id } = this.$route.params;
    if(!id) return this.$notify({ type: "danger", message: "id is required" });
    try {
      this.checkin = (await http.get(`/api/checkpoints/get-checkin/${id}`)).data.checkin;
      if(!this.event._id) await this.$store.dispatch('get', { path: 'events', key: 'event', id: this.checkin.event });
      this.loading = false;
    } catch (error) {
      this.$notify({
        type: "danger",
        message: error.response.data.message
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  
  *, *:before, *:after {
    box-sizing: border-box;
  }
  
  .checkmark-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    flex-direction: column;
  }
  
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes grow {
    0%, 100% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes checkmark {
    0%, 100% {
      opacity: 0;
      transform: scale(0);
    }
    10%, 50%, 90% {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>